import { N0 } from '@atlaskit/theme/colors';
import React from 'react';
import { allAppsWidth } from '../../Common/ReportsTableSummary';
import ReportSummaryOverview from '../../Common/ReportSummaryOverview';
import { getChartLinesDetails, getReportColumnsForSeries } from '../CloudConversions.utils';
export default function CloudConversionSummary(props) {
  const {
    totalSeries,
    reportName,
    period
  } = props;
  const reportMeta = {
    reportName,
    period
  };
  const reportColumns = getReportColumnsForSeries(totalSeries);
  const summary = [];
  reportColumns.forEach(column => {
    summary.push({
      head: column.key,
      content: column.content,
      color: column.key === 'Conversion rate' ? getChartLinesDetails(props.canUseLinePatterns)[0].color : N0,
      width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
    });
  });
  return /*#__PURE__*/React.createElement(ReportSummaryOverview, {
    reportMeta: reportMeta,
    summary: summary
  });
}